import { app } from '../checkpointHelper/app';
import { getAppRoleForApi } from './authz';
import type { Team } from './types';

export interface SettingsWorkspaceResponse {
    empty: boolean;
    teams: Team[];
}

function pmHeaders(): HeadersInit {
    const headers: Record<string, string> = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };

    headers['X-User-Id'] = String(app.window.member.user_id);
    headers['X-Checkpoint-User-Id'] = String(app.window.user.id);

    const appRole = getAppRoleForApi();
    if (appRole) {
        headers['X-App-Role'] = appRole;
    }

    return headers;
}

function userQuery(): string {
    return `?user_id=${encodeURIComponent(String(app.window.member.user_id))}`;
}

export async function fetchSettingsWorkspace(): Promise<SettingsWorkspaceResponse | null> {
    const response = await fetch(`/api/pm/workspace${userQuery()}`, {
        headers: pmHeaders(),
    });
    if (!response.ok) {
        console.warn('Settings workspace load failed', response.status);
        return null;
    }

    const body = (await response.json()) as { workspace?: SettingsWorkspaceResponse };
    return body.workspace ?? null;
}

export async function saveSettingsTeams(teamsPayload: Team[]): Promise<boolean> {
    const response = await fetch(`/api/pm/workspace${userQuery()}`, {
        method: 'PUT',
        headers: pmHeaders(),
        body: JSON.stringify({ teams: teamsPayload }),
    });
    if (!response.ok) {
        console.warn('Settings workspace save failed', response.status);
        return false;
    }
    return true;
}
